import type { DownloadCellVersions, DownloadRow } from "~/features/downloads/adapter";

/**
 * A cell is visible when its version filters either are empty (applies to all)
 * or include the active selection. Mirrors the legacy `shouldRenderContent`.
 */
export function isContentVisible(cell: DownloadCellVersions, activeHardware: string, activeFirmware: string): boolean {
  if (cell.firmwareSlugs.length > 0 && !cell.firmwareSlugs.includes(activeFirmware)) {
    return false;
  }
  if (cell.hardwareSlugs.length > 0 && !cell.hardwareSlugs.includes(activeHardware)) {
    return false;
  }
  return true;
}

/** Unique grouped-cell headings across the rows, preserving first-seen order. */
export function extractHeadings(rows: DownloadRow[]): string[] {
  const headings = new Set<string>();
  rows.forEach(row => {
    row.groupedCells.forEach(cell => {
      headings.add(cell.heading);
    });
  });
  return [...headings];
}

/** A product column is rendered only when it has visible content for the active filters. */
export function shouldRenderColumn(props: {
  heading: string;
  rows: DownloadRow[];
  activeHardware: string;
  activeFirmware: string;
}): boolean {
  const {
    heading,
    rows,
    activeHardware,
    activeFirmware
  } = props;
  return rows.some(row => {
    const cell = row.groupedCells.find(groupedCell => groupedCell.heading === heading);
    if (!cell?.content.length) {
      return false;
    }
    return cell.content.some(content => isContentVisible(content, activeHardware, activeFirmware));
  });
}